var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"d-flex align-center mt-5"},[_c('rir-icon',{staticClass:"mr-3",attrs:{"icon":"waiting"}}),_c('h2',{staticClass:"melia rocky--text"},[_vm._v(_vm._s(_vm.dataStatus.action))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }